import React from "react";
import { Select } from "antd";
import { RawMaterial } from "../../../Types";

const { Option } = Select;

interface Props {
  allRawMaterials: RawMaterial[];
  searchText: string;
  onSearchChange: (v: string) => void;
  onAdd: (materialId: string) => void;
}

export const IngredientPicker: React.FC<Props> = ({
  allRawMaterials,
  searchText,
  onSearchChange,
  onAdd,
}) => {
  const filtered = allRawMaterials.filter((rm) => {
    if (!searchText.trim()) return true;
    const q = searchText.toLowerCase();
    return (
      rm.name.toLowerCase().includes(q) || rm.code.toLowerCase().includes(q)
    );
  });

  return (
    <div className="flex items-center gap-3">
      <Select
        showSearch
        placeholder="Search and add an ingredient"
        filterOption={false}
        onSearch={onSearchChange}
        searchValue={searchText}
        onChange={onAdd}
        value={null}
        className="w-full max-w-sm"
      >
        {filtered.map((rm) => (
          <Option key={rm.id} value={rm.id}>
            {rm.name} ({rm.code})
          </Option>
        ))}
      </Select>
      <span className="text-xs text-gray-400">
        Add ingredients to build the recipe
      </span>
    </div>
  );
};
